/* ==========================================================================
   Zooted Prestige — locator-mini.js
   Homepage interactive retailer map (Leaflet + OpenStreetMap, no API key).
   Renders every retailer from locator-data.js as a cyan marker; popups link
   through to the full Find Zooted page. List/search stay on the full page.
   ========================================================================== */
(function () {
  'use strict';

  var el = document.querySelector('[data-mini-map]');
  if (!el) return;

  var findUrl = el.getAttribute('data-find-url') || '/pages/find-zooted';
  var mapSettings = (window.zootedSettings && window.zootedSettings.map) || {};

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function loadStylesheet(href) {
    return new Promise(function (resolve) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      l.onload = resolve; document.head.appendChild(l);
      setTimeout(resolve, 2500);
    });
  }

  function boot() {
    var retailers = (window.ZOOTED_RETAILERS || []).filter(function (r) { return r && r.lat && r.lng; });
    Promise.all([
      loadStylesheet('https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css'),
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js')
    ]).then(function () {
      var parts = String(mapSettings.center || '44.3148,-85.6024').split(',');
      var map = L.map(el, { scrollWheelZoom: false, zoomControl: true });
      map.setView([parseFloat(parts[0]) || 44.3148, parseFloat(parts[1]) || -85.6024], Number(mapSettings.zoom) || 6);
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors'
      }).addTo(map);
      // Scroll zoom only after the visitor clicks the map (avoids page-scroll traps)
      map.on('click', function () { map.scrollWheelZoom.enable(); });

      var bounds = L.latLngBounds([]);
      retailers.forEach(function (r) {
        var icon = L.divIcon({
          className: 'map-marker' + (r.featured ? ' is-featured' : ''),
          iconSize: [24, 24], iconAnchor: [12, 24], popupAnchor: [0, -24]
        });
        L.marker([r.lat, r.lng], { icon: icon, title: r.name, alt: r.name })
          .addTo(map)
          .bindPopup(
            '<strong>' + esc(r.name) + '</strong><br>' + esc(r.address) + ', ' + esc(r.city) +
            '<br><a href="' + findUrl + '?q=' + encodeURIComponent(r.city) + '">View in locator</a>'
          );
        bounds.extend([r.lat, r.lng]);
      });
      if (retailers.length > 1) map.fitBounds(bounds, { padding: [36, 36], maxZoom: 10 });

      var fb = el.querySelector('[data-mini-map-fallback]');
      if (fb) fb.remove();
    }).catch(function () { /* map CDN unreachable — fallback message stays */ });
  }

  // Lazy-boot when the section approaches the viewport
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); boot(); }
    }, { rootMargin: '300px' });
    io.observe(el);
  } else {
    boot();
  }
})();
